import { Component, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { CampaignsComponent } from './campaigns.component';
import { CampaignDetailComponent } from './campaign-detail.component';

@Component({
  selector: 'app-campaigns-workspace',
  template: `<app-workspace-master-detail [detailOpen]="detailOpen">
    <app-campaigns workspace-master></app-campaigns>
    <div workspace-detail class="workspace-page--full"><router-outlet (activate)="activated($event)" (deactivate)="deactivated()"></router-outlet></div>
  </app-workspace-master-detail>`,
  host: { class: 'workspace-master-detail-page' },
})
export class CampaignsWorkspaceComponent implements OnDestroy {
  @ViewChild(CampaignsComponent) collection?: CampaignsComponent;
  private detailChanges?: Subscription;
  constructor(private readonly route: ActivatedRoute) {}
  get detailOpen(): boolean { return this.route.firstChild !== null; }
  activated(component: unknown): void {
    this.deactivated();
    if (component instanceof CampaignDetailComponent) {
      this.detailChanges = component.saved.subscribe(() => this.collection?.refresh());
    }
  }
  deactivated(): void { this.detailChanges?.unsubscribe(); }
  ngOnDestroy(): void { this.deactivated(); }
}
